import React from "react";
import PropTypes from "prop-types";
import buildNavContainer, { navShape } from "./buildNavContainer";
import Button from "lib/common/descriptorcontrols/BaseControls/Button";
import Dispatcher from "Dispatcher";
import SuperRecordActions from "data/SuperRecordActions";

export class BreadcrumbNavigator extends React.Component {

    onSelectItem(e, item) {
        e.preventDefault();
        const {
            onSelectImpl,
            onSelectRecord,
        } = this.props;
        if (item.isMagic) {
            onSelectImpl(item.projections[0].implementationKey);
        } else {
            onSelectRecord(item.entityKey, item.id);
        }
    }

    render() {
        const {
            tree,
            items,
            onDelete,
        } = this.props;
        return <div className="button-group">
            <div className="root">
                <a className="entity" href="#"
                   onClick={e => this.onSelectItem(e, tree)}>{tree.label}
                    {tree.detail &&
                    <span className="entity-detail"> - {tree.detail}</span>}
                </a>
                {!tree.supportsEnablement &&
                <Button
                    enabled={true}
                    onClick={onDelete}
                    options={[{
                        value: "delete",
                        label: `Delete ${tree.name}`,
                    }]}
                    className={"btn-link dropdown-toggle"}
                    collapse={false}
                />}
            </div>
            <div className="navigator btn-group">
                {items.map(item =>
                    <span key={item.id}>
                        <span className="glyphicon glyphicon-chevron-up" />
                        <a className="title"
                           onClick={e => this.onSelectItem(e, item)}>
                            {item.label}
                        </a>
                    </span>,
                )}
            </div>
        </div>;
    }

}

BreadcrumbNavigator.propTypes = {
    ...navShape,
    onDelete: PropTypes.func.isRequired,
};

const findSelectedItems = tree => {
    const result = [];
    const doFields = fields => {
        if (fields == null) return;
        for (const f of fields) {
            doItems(f.items);
        }
    };
    const doItems = items => {
        if (items == null) return;
        for (const it of items) {
            doItem(it);
        }
    };
    const doItem = it => {
        if (!it.selected) return;
        result.push(it);
        doFields(it.fields);
    };
    if (tree.isMagic) {
        doFields(tree.fields);
    } else {
        doFields(tree.items[0].fields);
    }
    return result;
};

export const FluxBreadcrumbNavigator = buildNavContainer(
    BreadcrumbNavigator,
    (raw, contained) => ({
        ...contained,
        items: findSelectedItems(contained.tree),
        onDelete: () =>
            Dispatcher.contextDispatch(raw.fluxContext, {
                type: SuperRecordActions.DELETE_RECORD,
                key: contained.tree.key,
                id: contained.tree.id,
            }),
    }),
);



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/BreadcrumbNavigator.js